import type { AuthService } from 'app/shared/services/auth/auth.service';
import { AppInjector } from 'app/app-injector'; // do not import AppModule here instead - breaks ng test (circular dependency)
import { throwError } from 'rxjs';
import { environment } from 'environments/environment';

declare const require: any;

// Resolved at call time rather than module-evaluation time. A static import of
// AuthService here forms a value-level cycle (AuthService ->
// PasswordPolicyService -> extends ServiceBase) that throws
// "Cannot access 'ServiceBase' before initialization" under Karma's module
// evaluation order. The `import type` above is erased at compile time, so this
// deferred lookup is the only runtime edge.
function authServiceToken(): any {
    return require('app/shared/services/auth/auth.service').AuthService;
}

export class ServiceBase {

    options: any;
    authService: AuthService;
    public dimensionPassword: string;
    public dimensionUsername: string;
    public webSocketRetry: number;
    public sendNotificationURI: string;
    public notificationURI: string;
    public authorityUrl: string;
    constructor() {
        this.authService = AppInjector.injector.get(authServiceToken());
        this.dimensionUsername = environment.dimensionUsername;
        this.dimensionPassword = environment.dimensionPassword;
        this.authorityUrl = environment.authorityService;
        this.webSocketRetry = environment.webSocketRetry;
        this.sendNotificationURI = environment.sendNotificationURI;
        this.notificationURI = environment.notificationURI;
    }

    serializeToQueryString(objectToSerialize: any): string {

        let queryString = '?';
        queryString += Object.keys(objectToSerialize).map((key) => {
            if (objectToSerialize[key] === null) {
                return `${encodeURIComponent(key)}=`;
            }
            if (objectToSerialize[key] instanceof Date) {
                return `${encodeURIComponent(key)}=${encodeURIComponent((objectToSerialize[key] as Date).toISOString())}`;
            } else {
                return `${encodeURIComponent(key)}=${encodeURIComponent(objectToSerialize[key])}`;
            }

        }).join('&');

        if (queryString === '?') {
            queryString = '';
        }
        var unwantedStr = /undefined|NaN/gi;
        queryString = queryString.replace(unwantedStr, "");

        return queryString;
    }

    serializeQueryStringLocalDateTime = (objectToSerialize: any): string => {

        let queryString = '?';
        queryString += Object.keys(objectToSerialize).map((key) => {
            if (objectToSerialize[key] === null) {
                return `${encodeURIComponent(key)}=`;
            }
            if (objectToSerialize[key] instanceof Date) {
                const date = `${objectToSerialize[key].toLocaleDateString()},${objectToSerialize[key].toLocaleTimeString()}`
                return `${encodeURIComponent(key)}=${date}`;
            } else {
                return `${encodeURIComponent(key)}=${encodeURIComponent(objectToSerialize[key])}`;
            }
        }).join('&');

        if (queryString === '?') {
            queryString = '';
        }
        var unwantedStr = /undefined|NaN/gi;
        queryString = queryString.replace(unwantedStr, "");
        return queryString;
    }

    protected handleError(error: Response | Error) {
        if (error instanceof Error) {
            return throwError((error as Error).message);
        }
        const errorResponse = error as Response;
        if (errorResponse.status && errorResponse.status === 401) {
            // Unauthorized
            this.authService = AppInjector.injector.get(authServiceToken());
            this.authService.signinRedirect();
            return throwError('Please wait for sign in...');
        }

        try {
            return throwError(errorResponse.statusText);
        } catch (e) {
            return throwError(errorResponse.statusText);
        }
    }
}
